<div class="general">
  <div id="main-body" (mousemove)="mouseParallax($event)">
    <header class="main-header">
      <img src="favicon.ico" alt="Наша клубная эмблема">
      <div class="links">
        <button mat-button routerLink="/about">О клубе</button>
        <button mat-button routerLink="/map">Карта</button>
        <button mat-button routerLink="/gallery">Фотогалерея</button>
        <button mat-button routerLink="/contacts">Контакты</button>
        <button mat-icon-button routerLink="/login">
          <mat-icon>login</mat-icon>
        </button>
      </div>
      <button mat-icon-button class="mobile-menu-button" [matMenuTriggerFor]="mobile_menu">
        <mat-icon>menu</mat-icon>
      </button>
    </header>
    <div class="title">
      <h1>Алмасты <sup style="font-size: .5em" *ngIf="!production">Dev</sup></h1>
      <h4>Туристский клуб</h4>
    </div>
    <div class="scrolldown-container" (click)="scroll_down()" id="scroll_down_container">
      <div class="chevron"></div>
      <div class="chevron"></div>
      <div class="chevron"></div>
    </div>
  </div>
</div>
<app-news></app-news>
<mat-menu #mobile_menu="matMenu">
  <button mat-menu-item routerLink="/about">О клубе</button>
  <button mat-menu-item routerLink="/map">Карта</button>
  <button mat-menu-item routerLink="/gallery">Фотогалерея</button>
  <button mat-menu-item routerLink="/contacts">Контакты</button>
  <button mat-menu-item routerLink="/login">Войти</button>
</mat-menu>
